import Vue from 'vue'
import dayjs from 'dayjs'

// 加载中文语言包
// import 'dayjs/locale/zh-cn'
//引入相对时间插件
// import relativeTime from 'dayjs/plugin/relativeTime'

// 配置使用处理相对时间的插件
// dayjs.extend(relativeTime)

// 配置使用中文语言包
// dayjs.locale('zh-cn')

// 全局过滤器：处理相对时间
// Vue.filter('relativeTime', value => {     //value即为使用这个过滤器 
//   return dayjs().to(dayjs(value))
// })


dayjs().format('YYYY/MM/DD HH:mm:ss'), //真实时间

// 过滤时间为 年月日
Vue.filter('yymmdd', value => {     
  return toyymmdd(value)
})
function toyymmdd(yyvalue){
  return dayjs(yyvalue).format('YYYY-MM-DD')
}


// 过滤毫秒
Vue.filter('mmssTime', value => {     
  return formatMsToDate(value)
  })

    //该方法用于 {秒数补零} 
    function ssaddZero(num) {
      if (parseInt(num) < 10) {
          num = "0" + num
      }
      num += ''
      // 没有小数点的补00
      if (!/\./.test(num)) {
        num += '.00'
      }
      let arrayNum = num.split('.')
      // 截成2个元素的数组  取第二个元素{小数点后的数字}进行判断 长度不为2的补0
      if (arrayNum[1].length < 2) {
        num += '0'
      }
      return num
    }
    //该方法用于给日期、时间补零
    function addZero(num) {
      if (parseInt(num) < 10) {
          num = "0" + num
      }
      return num
    }

    //参数 毫秒数   把毫秒数转化成具体日期   00 00:00:00
    function formatMsToDate (msvalue) {
      let cs = msvalue / 1000
      // let ss = addZero(Math.floor(cs % 60)); //  秒(取整)
      // let ss = addZero(cs % 60); //  秒（原数）
      let ss = ssaddZero( Math.round( (cs % 60) * 100 ) / 100 ); //  秒（小数点后两位）

      let mm = addZero(Math.floor(cs / 60) % 60); //  分
      let hour = addZero(Math.floor(cs / 60 / 60) % 24); //时
      let day = addZero(Math.floor(cs / 60 / 60 / 24)); //天数
      return `${mm}:${ss}`

    }

// 过滤字符串（截取字符串）
Vue.filter("handstring",value => {
  return handlestirng(value)
})
// 处理字符串函数
function handlestirng(val){
  const arr = val.split("比赛地点：")
  // 将字符串按 "比赛地点："  截取成两段 （数组中的两个元素）
  // console.log(arr)
  return arr[1]
}